module.exports = __webpack_public_path__ + "static/img/btn_03.e2361a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv001/btn_03.jpg
// module id = flce
// module chunks = 0